import { gql } from "@apollo/client";

export const GET_MASTER_DATA_PRODUCT_CATEGORIES = gql`
  query MasterDataProductCategories(
    $params: MasterDataProductCategoriesParamsInput!
  ) {
    masterDataProductCategories(params: $params) {
      total
      page
      limit
      items {
        productCategoryId
        categoryKey
        name
        description
        isActive
        searchVectorKeywords
      }
    }
  }
`;
